export { default as DeletionConfirmation } from './DeletionConfirmation'
export { default as StyledDeletionConfirmation } from './DeletionConfirmation.Styled'
